import { api } from './apiService';

/**
 * Run agentic workflow
 * @param {string} input - User prompt
 * @param {string} [sessionKey] - Optional client-generated session key
 * @returns {Promise<Object>}
 */
export async function runAgentic(input, sessionKey) {
  try {
    const response = await api.post('/agentic/run', {
      input,
      sessionKey: sessionKey || undefined,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * Continue an existing agentic conversation
 * @param {string} sessionId - Existing session id
 * @param {string} input - Follow-up user message
 * @returns {Promise<Object>}
 */
export async function sendAgenticMessage(sessionId, input) {
  try {
    const response = await api.post(`/agentic/sessions/${sessionId}/chat`, {
      input,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * Fetch paginated agentic sessions
 * @param {number} [page=1]
 * @param {number} [limit=20]
 * @returns {Promise<Object>}
 */
export async function fetchAgenticSessions(page = 1, limit = 20) {
  try {
    const response = await api.get('/agentic/sessions', {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * Fetch one session + timeline interactions
 * @param {string} sessionId
 * @param {number} [page=1]
 * @param {number} [limit=200]
 * @returns {Promise<Object>}
 */
export async function fetchAgenticSessionById(sessionId, page = 1, limit = 200) {
  try {
    const response = await api.get(`/agentic/sessions/${sessionId}`, {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}